import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OperationType } from './models/operation-type.model';
import { ProgressAllocation, ReportKind, WorkLine } from './models/work-line.model';

export interface ProgressReportResponseDto {
  reportId: number;
  reportedAt: string;
  reportedByUserId: number | null; // null only for reports from before attribution (0059); not displayed yet
  reportedByName: string | null;
  operationTypeId: number | null;
  completesItem: boolean;
  lines: { orderItemId: number; orderId: number; amount: number }[];
}

export interface SkipOperationResponseDto {
  reportId: number;
  reportedAt: string;
  reportedByUserId: number | null;
  reportedByName: string | null;
}

@Injectable({ providedIn: 'root' })
export class ProductionOverseerProvider {
  constructor(private http: HttpClient) {}

  getWorkLines(): Observable<WorkLine[]> {
    const url = `/api/production/work-lines`;
    return this.http.get<WorkLine[]>(url);
  }

  getOperationTypes(): Observable<OperationType[]> {
    const url = `/api/operation-types`;
    return this.http.get<OperationType[]>(url);
  }

  // No position appends; a position inserts at that slot (the API renumbers the rest)
  createOperationType(name: string, position?: number): Observable<OperationType> {
    const url = `/api/operation-types`;
    return this.http.post<OperationType>(url, { name, position: position ?? null });
  }

  renameOperationType(id: number, name: string): Observable<void> {
    const url = `/api/operation-types/${id}`;
    return this.http.patch<void>(url, { name });
  }

  deleteOperationType(id: number): Observable<void> {
    const url = `/api/operation-types/${id}`;
    return this.http.delete<void>(url);
  }

  reportProgress(allocations: ProgressAllocation[], kind: ReportKind): Observable<ProgressReportResponseDto> {
    const url = `/api/production/reports`;
    const request = {
      allocations: allocations.map(a => ({ orderItemId: a.lineId, amount: a.delta })),
      operationTypeId: kind.operationTypeId,
      completesItem: kind.completesItem
    };
    return this.http.post<ProgressReportResponseDto>(url, request);
  }

  // skips = false is Przywróć. Undone like any report — undoReport with the returned id
  skipOperation(lineIds: number[], operationTypeId: number, skips: boolean): Observable<SkipOperationResponseDto> {
    const url = `/api/production/skips`;
    return this.http.post<SkipOperationResponseDto>(url, { orderItemIds: lineIds, operationTypeId, skips });
  }

  undoReport(reportId: number): Observable<void> {
    const url = `/api/production/reports/${reportId}`;
    return this.http.delete<void>(url);
  }
}
